/**
 * @type module
 * Wyszukuje słowo kluczowe w obecnie zazaczonych lokalizacjach i generuje listę HTML z podpowiedziami,
 * udostępnia funkcje czyszczenia pola wyszukiwarki, aktualizacji listy podpowiedzi, dodaje obsługę strzałkami na liście podpowiedzi
 * Wyszukiwarka może być w dwóch trybach o czym informuje zmienna searchForCity - w trybie wyszukiwania miast, jeśli true lub punktów odbioru
 */
app.service('shopLocatorSearch', function( shopLocatorManager, shopLocatorMap ) {

	var $input, $search, $list, $listItems, $selected, searchForCity = true;

	function findMatches( wordToMatch, visibleLocations, exact ) {
		wordToMatch = wordToMatch.trim();
		var exact = exact || false;
		var pattern = exact ? '^' + wordToMatch + '$' : wordToMatch;
		var regExp = new RegExp(pattern, 'gi');

		return visibleLocations.filter( function( location ) {
			return ( location !== undefined ) && ( location.city.match( regExp ) || location.postCode.match( regExp ) );
		}).map( function( location ) {
			return location;
		});
	}

	function updateSearchList() {
		var value = $input.val();
		$input.focus();
		if(searchForCity) {
			findCities( value );
		} else {
			findShops( value, true );
		}
	}

	function findShops( searchValue, skipMarkers ) {
		$list.empty();
		searchForCity = false;
		var visibleLocations = shopLocatorManager.getVisibleLocations();
		var locations = findMatches( searchValue, visibleLocations, true );
		var html = getShopsListHTML( locations );

		!skipMarkers && shopLocatorMap.show( locations );
		$list.show().html( html );
		$input.val( searchValue );
		$selected = '';
		$listItems = $list.find('.js-place');
	}

	function getShopsListHTML( locations ) {
		return locations.map(function(location) {
			return '<div class="search-list-item js-place" data-code="' + location.code + '"><b>' + location.title + '</b><br>' + '<small>' + location.street + '<br>'   + location.postCode + ' ' + location.city + '</small></div>';
		}).join('');
	}

	var findCities = debounce(function( searchValue ) {
		searchForCity = true;
		if( searchValue.length < 2 ) {
			clear();
			return false;
		}
		var visibleLocations = shopLocatorManager.getVisibleLocations();
		var locations = findMatches( searchValue, visibleLocations ); // zwraca znalezione punkty odbioru
		var html = getCitiesListHTML( locations ).join('');
		$search.removeClass('search').addClass('cancel');
		$list.show().html( html );
		$selected = '';
		$listItems = $list.find('.js-city');
	}, 250);

	function getCitiesListHTML( locations ) {
		var cities = [];
		return locations.map(function(location) {
				if( !(cities.indexOf( location.city ) !== -1) ) {
						cities.push(location.city);
						return '<div class="search-list-item js-city">' + location.city + '</div>';
				}
		});
	}

	function showListItem( $selected ) {
		if( searchForCity ) {
			findShops( $selected.text() );
			searchForCity = false;
		} else {
			var code = $selected.addClass('active').data('code');
			$listItems.not( $selected ).removeClass('active');
			shopLocatorMap.zoom( String(code) );
		}
	}

	function scrollToView( type, $selected ) {
		var listScrollTop = $list.scrollTop(),
			currentItemHeight = $selected.outerHeight(true),
			currentTopPosition = $selected.position().top,
			absCurrentTopPosition = Math.abs(currentTopPosition),
			listHeight = $list.height();

		if(type ===  'down') {
			if (listHeight - currentTopPosition < currentItemHeight) {
				$list.scrollTop((listScrollTop + (absCurrentTopPosition - listHeight + currentItemHeight)));
			}
		}

		if(type === 'up' ) {
			if (currentTopPosition < -1) {
				$list.scrollTop(listScrollTop - absCurrentTopPosition);
			}
		}
	}

	function checkZipCode( code ) {
		var pattern = /^\d{2}-\d{3}$/;
		return pattern.test(code);
	}

	function handleSelection( keyCode ) {
		var $nextElement = $selected, scrollType;
		
		if( keyCode === 13 ) {
			if( $selected ) {
				showListItem( $selected );
			} else {
				var searchValue = $input.val();
				if( checkZipCode( searchValue ) ) {
					var activeFilters = 'shop';
					shopLocatorManager.getLocationsByZipCode(activeFilters, searchValue)
						.then(function(locations) {
							shopLocatorMap.show( locations );
						});
				}
			}
		}

		if( !$selected ) {
			$nextElement = $listItems.first();
		} else if( keyCode === 40 ) {
			$nextElement = $selected.nextAll().first();
			scrollType = 'down';
		} else if( keyCode === 38 ) {
			$nextElement = $selected.prevAll().first();
			scrollType = 'up';
		}

		if( $nextElement.length ) {
			$selected = $nextElement;
			scrollToView( scrollType, $selected );
		} else {
			return false;
		}

		$listItems.not( $selected ).removeClass( 'active' );
		$selected.addClass( 'active' );
		return false;
	}

	function clear( clearInput ) {
		var clearInput = clearInput || false;
		$search.removeClass('cancel').addClass('search');
		$list.empty();
		searchForCity = true;
		if( clearInput ) {
			$input.val('');
		}
	}

	function debounce(func, wait, immediate) {
		var timeout;
		return function() {
				var context = this, args = arguments;
				var later = function() {
						timeout = null;
						if (!immediate) func.apply(context, args);
				};
				var callNow = immediate && !timeout;
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (callNow) func.apply(context, args);
		};
	}

	function init($self) {
		$input = $('.search-input', $self);
		$list = $('.js-search-list', $self);
		$search = $('.js-search', $self);

		$search.click(function() {
			if( $(this).hasClass('cancel') ) {
				clear( true );
				$input.focus();
			} else {
				return false;
			}
		});
	}

	return {
		init: init,
		findCities: findCities,
		findShops: findShops,
		handleSelection: handleSelection,
		clear: clear,
		updateSearchList: updateSearchList
	};
});
